import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IPersonalInfo, ContactInfo, IPPActivation, IAddressHistoryInfo } from 'src/app/models/IPersonalInfo';
import { IAttributes } from 'src/app/models/IAttributes';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { ICityDetails } from 'src/app/models/ICityDetails';
import { IInsuranceStatus } from 'src/app/models/IInsuranceStatus';
import { IEmergencyContact } from 'src/app/models/IEmergencyContact';
import { IInsuranceCarriers } from 'src/app/models/IInsuranceCarriers';
import { IRelationships } from 'src/app/models/IRelationships';
import { IInsuranceDetails } from 'src/app/models/IInsuranceDetails';
import { IHPIDetails } from 'src/app/models/IHPIDetails';
import { IAuthorization } from 'src/app/models/IAuthorization';
import { IPatientAuthorizationEmrSync } from 'src/app/models/IPatientAuthorizationEmrSync';
import { ISymptoms } from 'src/app/models/ISymptoms';
import { IDemoNotes } from 'src/app/models/IDemoNotes';
import { IAlerts } from 'src/app/models/IAlerts';
import { IInsPlaneNames } from 'src/app/models/IInsPlaneNames';
import { IPatientReferrals } from 'src/app/models/IPatientReferrals';
import { IReferralDetails } from 'src/app/models/IReferralDetails';
import { IPostPaymentDetails } from 'src/app/models/IPostPaymentDetails';
import { IRcmPaymentSaveRequest } from 'src/app/models/IRcmPaymentSaveRequest';
import { IPatientPaymentEmrSyncItem } from 'src/app/models/IPatientPaymentEmrSyncItem';
import { IPatientPaymentDetailEmrSyncItem } from 'src/app/models/IPatientPaymentDetailEmrSyncItem';
import { configuration } from 'src/environments/environment';
import { IPatientPharmacy } from 'src/app/models/IPatientPharmacy';
import { IPatientReferralTrackers } from 'src/app/models/IPatientReferralTrackers';
import { IPatientDetails } from 'src/app/models/IEPrescriptionXMLDTO';
import { IPatientPortaInformation } from 'src/app/models/IPatientPortaInformation';
import { MessageInbox } from 'src/app/models/IMessaging';
@Injectable({
  providedIn: 'root'
})

export class PersonalInfoService {

  constructor(private http: HttpClient) { }

  getPersonalInfo(id: number): Observable<IPersonalInfo> {
    const Personal_PenRequest = {
      patientid: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      clientid: sessionStorage.getItem("FacilityId"),
      portal: null
    }
    return this.http.post<IPersonalInfo>(
      `${configuration.apiUrl + 'Patient/getPersonal'}`, Personal_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  addPersonalInfo(personInfo: IPersonalInfo): Observable<IPersonalInfo> {
    const signatureSizeImage = personInfo.patientPic;
    personInfo.patientPic = null;
    const posteddata = {
      inputdata: JSON.stringify(personInfo),
      signature: (signatureSizeImage)
    }
    return this.http.post<IPersonalInfo>(`${configuration.apiUrl + 'Patient/Personal'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  updatePersonalInfo(personInfo: IPersonalInfo): Observable<void> {
    const signatureSizeImage = personInfo.patientPic;
    personInfo.patientPic = null;
    const posteddata = {
      inputdata: JSON.stringify(personInfo),
      signature: (signatureSizeImage)
    }
    return this.http.post<void>(`${configuration.apiUrl + 'Patient/UpdPersonal'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getInsStatus(): Observable<IInsuranceStatus[]> {
    return this.http.get<IInsuranceStatus[]>(`${configuration.apiUrl + 'Master/InsuranceType'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  addEmergencyInfo(emergencyInfo: IEmergencyContact): Observable<IEmergencyContact> {
    ;
    return this.http.post<IEmergencyContact>(`${configuration.apiUrl + 'Patient/Emergency'}`, emergencyInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  updateEmergencyInfo(emergencyInfo: IEmergencyContact): Observable<IEmergencyContact> {
    return this.http.post<IEmergencyContact>(`${configuration.apiUrl + 'Patient/UpdEmergency'}`, emergencyInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteSelectEmgContactNoInfo(Id: number): Observable<number> {
    return this.http.delete<number>(`${configuration.apiUrl + 'Patient/Emergency'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getEmergencyInfo(id: number): Observable<IEmergencyContact[]> {
    const Emergency_PenRequest = {
      patid: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<IEmergencyContact[]>(
      `${configuration.apiUrl + 'Patient/GetEmergency'}`, Emergency_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getInsMasters(): Observable<IInsuranceStatus[]> {
    return this.http.get<IInsuranceStatus[]>(`${configuration.apiUrl + 'Master/InsuranceType'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }



  getInsCarriers(): Observable<IInsuranceCarriers[]> {
    return this.http.get<IInsuranceCarriers[]>(`${configuration.apiUrl + 'Master/ActivePayers'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&FacilityId=${sessionStorage.getItem("FacilityId")}`);
  }

  getInsRelationships(): Observable<IRelationships[]> {
    return this.http.get<IRelationships[]>(`${configuration.apiUrl + 'Master/EmergencyRelations'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  getInsuranceDetails(id: number): Observable<IInsuranceDetails> {
    const Insurance_PenRequest = {
      patid: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<IInsuranceDetails>(
      `${configuration.apiUrl + 'Patient/GetInsurance'}`, Insurance_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // getInsuranceDetailsbyId(id: number): Observable<IInsuranceDetails> {
  //   return this.http.get<IInsuranceDetails>(
  //     `${configuration.apiUrl + 'Patient/InsurancebyId'}?id=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  // }

  getInsuranceDetailsbyId(id: number): Observable<IInsuranceDetails> {
    const InsurancebyId_PenRequest = {
      id: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<IInsuranceDetails>(
      `${configuration.apiUrl + 'Patient/InsurancebyId'}`, InsurancebyId_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  addInsuranceDetails(insInfo: IInsuranceDetails): Observable<IInsuranceDetails> {
    return this.http.post<IInsuranceDetails>(`${configuration.apiUrl + 'Patient/Insurance'}`, insInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  updateInsuranceDetails(insInfo: IInsuranceDetails): Observable<IInsuranceDetails> {
    return this.http.post<IInsuranceDetails>(`${configuration.apiUrl + 'Patient/UpdInsurance'}`, insInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteSelectInsInfo(Id: number): Observable<string> {
    return this.http.delete<string>(`${configuration.apiUrl + 'Patient/Insurance'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // -- HPI Screen Methods -- //

  getHPIDetails(encounterId: string): Observable<IHPIDetails[]> {
    return this.http.get<IHPIDetails[]>(`${configuration.apiUrl + 'Master/AllHPIDetails'}?encounterid=${encounterId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getSymptomsDetails(): Observable<ISymptoms[]> {
    return this.http.get<ISymptoms[]>(`${configuration.apiUrl + 'Master/symptoms'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  addAuthorizationDetails(authorizationinfo: IAuthorization): Observable<IAuthorization> {
    const posteddata = {
      inputdata: JSON.stringify(authorizationinfo)
    }
    return this.http.post<IAuthorization>(`${configuration.apiUrl + 'Patient/InsertAuthorization'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  updateAuthorizationDetails(authorizationinfo: IAuthorization): Observable<IAuthorization> {
    const posteddata = {
      inputdata: JSON.stringify(authorizationinfo)
    }
    return this.http.post<IAuthorization>(`${configuration.apiUrl + 'Patient/UpdateAuthorization'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  DeleteSelectAuthInfo(Id: number): Observable<string> {
    return this.http.delete<string>(`${configuration.apiUrl + 'Patient/Authorization'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // getAuthorizationDetails(id: number): Observable<IAuthorization> {
  //   return this.http.get<IAuthorization>(
  //     `${configuration.apiUrl + 'Patient/Authorization'}?patid=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  // }

  // Backend now proxies to Integration.API's RCM authorization-sync endpoint
  // (PatientController.GetAuthorizationDetailsTService -> PatientDao.GetPatientAuthorizationsFromIntegrationApi),
  // which returns a list of the patient's authorizations, not a single record.
  getAuthorizationDetails(id: number): Observable<IPatientAuthorizationEmrSync[]> {
    const _authorization_PenRequest = {
      patid: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<IPatientAuthorizationEmrSync[]>(
      `${configuration.apiUrl + 'Patient/GetAuthorization'}`, _authorization_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  insertUpdateDemoNotes(Notesdetails: IDemoNotes, Notes: any): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Patient/PatientNotes'}?Notes=${Notes}`, Notesdetails, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getDemoNotes(patId: number): Observable<IDemoNotes[]> {
    return this.http.get<IDemoNotes[]>(
      `${configuration.apiUrl + 'Patient/PatientNotes'}?patId=${patId}`);
  }

  DeleteSelectNotesInfo(Id: number): Observable<string> {
    return this.http.delete<string>(`${configuration.apiUrl + 'Patient/PatientNotes'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  // getAlertsInfo(id: number,locationId:number): Observable<IAlerts> {
  //   return this.http.get<IAlerts>(
  //     `${configuration.apiUrl + 'Patient/Alerts'}?patientId=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}&&locationId=${locationId}`);
  // }

  getAlertsInfo(id: number, locationId: number): Observable<IAlerts> {
    const alert_PenRequest = {
      patientId: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId"),
      locationId: locationId
    }
    return this.http.post<IAlerts>(
      `${configuration.apiUrl + 'Patient/GetAlerts'}`, alert_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  addAlertsInfo(alertsInfo: IAlerts): Observable<IAlerts> {
    const posteddata = {
      inputdata: JSON.stringify(alertsInfo)
    }
    return this.http.post<IAlerts>(`${configuration.apiUrl + 'Patient/InsertAlert'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  updateAlertsInfo(alertsInfo: IAlerts): Observable<IAlerts> {
    const posteddata = {
      inputdata: JSON.stringify(alertsInfo)
    }
    return this.http.post<IAlerts>(`${configuration.apiUrl + 'Patient/UpdateAlert'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteSelectAlertInfo(Id: number): Observable<string> {
    return this.http.delete<string>(`${configuration.apiUrl + 'Patient/Alert'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getPlaneNamesInfo(): Observable<IInsPlaneNames[]> {
    return this.http.get<IInsPlaneNames[]>(
      `${configuration.apiUrl + 'Master/PlanNames'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  getInsPlaneNamesInfo(): Observable<IInsPlaneNames[]> {
    return this.http.get<IInsPlaneNames[]>(
      `${configuration.apiUrl + 'Master/InsPlanNames'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }


  // getPatReferralDetails(id: number): Observable<IPatientReferrals[]> {
  //   return this.http.get<IPatientReferrals[]>(
  //     `${configuration.apiUrl + 'Patient/Referral'}?patid=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  // }
  getPatReferralDetails(id: number): Observable<IPatientReferrals[]> {
    const referral_PenRequest = {
      patid: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<IPatientReferrals[]>(
      `${configuration.apiUrl + 'Patient/GetReferral'}`, referral_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  // getPatReferralDetailsbyRefId(id: number): Observable<IPatientReferrals[]> {
  //   return this.http.get<IPatientReferrals[]>(
  //     `${configuration.apiUrl + 'Patient/ReferralbyId'}?id=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  // }
  getPatReferralDetailsbyRefId(id: number): Observable<IPatientReferrals[]> {
    const referral_PenRequest = {
      id: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<IPatientReferrals[]>(
      `${configuration.apiUrl + 'Patient/ReferralbyId'}`, referral_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getReferalProvidersInfo(): Observable<IReferralDetails[]> {
    return this.http.get<IReferralDetails[]>(`${configuration.apiUrl + 'Patient/ReferralProviders'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  addPatReferralDetails(insInfo: IPatientReferrals): Observable<IPatientReferrals> {
    const posteddata = {
      inputdata: JSON.stringify(insInfo)
    }
    return this.http.post<IPatientReferrals>(`${configuration.apiUrl + 'Patient/InsertReferral'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  updatePatReferralDetails(insInfo: IPatientReferrals): Observable<IPatientReferrals> {
    const posteddata = {
      inputdata: JSON.stringify(insInfo)
    }
    return this.http.post<IPatientReferrals>(`${configuration.apiUrl + 'Patient/UpdateReferral'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteSelectRefInfo(Id: number): Observable<string> {
    return this.http.delete<string>(`${configuration.apiUrl + 'Patient/Referral'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // getPostPaymentInfo(id: number): Observable<IPostPaymentDetails> {
  //   return this.http.get<IPostPaymentDetails>(
  //     `${configuration.apiUrl + 'Patient/Account'}?patientId=${id}&&facility=${sessionStorage.getItem("FacilityId")}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  // }
  // Patient/Account now sources from RCM via Integration.API's GET api/Payment/search
  // passthrough (EMR.API's GetPostPayDetailsByPatId), returning PatientPaymentEmrSyncItem
  // instead of the retired local-EMR IPostPaymentDetails shape.
  getPostPaymentInfo(id: number): Observable<IPatientPaymentEmrSyncItem[]> {
    const account_PenRequest = {
      patientid: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<IPatientPaymentEmrSyncItem[]>(
      `${configuration.apiUrl + 'Patient/Account'}`, account_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  addPostPaymentInfo(alertsInfo: IPostPaymentDetails): Observable<IPostPaymentDetails> {
    const posteddata = {
      inputdata: JSON.stringify(alertsInfo)
    }
    return this.http.post<IPostPaymentDetails>(`${configuration.apiUrl + 'Patient/InsertAccount'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Payments now live in RCM (BillingAPI) — proxies Integration.API's POST api/Payment
  // (EMR.API's Patient/SaveAccountToRcm), which proxies BillingAPI's PaymentController.
  // SavePayment. Single endpoint for both insert and update: request.paymentId null
  // means insert, set means update. Returns the saved PaymentId.
  savePaymentToRcm(request: IRcmPaymentSaveRequest): Observable<number> {
    const posteddata = {
      inputdata: JSON.stringify(request),
      createdBy: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<number>(`${configuration.apiUrl + 'Patient/SaveAccountToRcm'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Proxies EMR.API's Patient/PaymentDetails, which proxies Integration.API's GET
  // api/Payment/details passthrough (BillingAPI's GetDetails/GetDetailsByPaymentId
  // merged with GetPaymentModes into one response). SourceId is tried first when
  // supplied; PaymentId is the fallback — pass whichever the payments-list row has.
  getPaymentDetails(sourceId: string, paymentId: number, facilityId: number): Observable<IPatientPaymentDetailEmrSyncItem> {
    const paymentDetails_PenRequest = {
      sourceId: sourceId || '',
      paymentId: paymentId ? String(paymentId) : '',
      facilityId: facilityId ? String(facilityId) : ''
    }
    return this.http.post<IPatientPaymentDetailEmrSyncItem>(
      `${configuration.apiUrl + 'Patient/PaymentDetails'}`, paymentDetails_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Proxies EMR.API's Patient/UpdatePaymentStatus, which proxies Integration.API's
  // PUT api/Payment/{paymentId}/status passthrough (BillingAPI's PaymentController.
  // UpdateStatus). Used by the Void Payment action — paymentStatus is 'Voided' and
  // notes carries the mandatory void reason.
  updatePaymentStatus(paymentId: number, paymentStatus: string, notes: string, facilityId: number): Observable<any> {
    const updatePaymentStatus_PenRequest = {
      paymentId: paymentId ? String(paymentId) : '',
      paymentStatus: paymentStatus || '',
      notes: notes || '',
      facilityId: facilityId ? String(facilityId) : '',
      createdBy: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<any>(
      `${configuration.apiUrl + 'Patient/UpdatePaymentStatus'}`, updatePaymentStatus_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  CheckSSNInfo(id: number, ssn: string): Observable<number> {
    const CheckSSN_PenRequest = {
      patid: id,
      ssn: ssn,
      clientid: sessionStorage.getItem("FacilityId"),
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<number>(
      `${configuration.apiUrl + 'Patient/CheckSSN'}`, CheckSSN_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  addPatPharmacyInfo(pharmacyInfo: IPatientPharmacy): Observable<IPatientPharmacy> {
    return this.http.post<IPatientPharmacy>(`${configuration.apiUrl + 'Patient/InsertPharmacy'}`, pharmacyInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  updatePatPharmacyInfo(pharmacyInfo: IPatientPharmacy): Observable<IPatientPharmacy> {
    return this.http.post<IPatientPharmacy>(`${configuration.apiUrl + 'Patient/UpdatePharmacy'}`, pharmacyInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // getPatPharmacyInfo(id: number): Observable<IPatientPharmacy> {
  //   return this.http.get<IPatientPharmacy>(
  //     `${configuration.apiUrl + 'Patient/GetPharmacy'}?patientId=${id}&&facility=${sessionStorage.getItem("FacilityId")}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  // }
  getPatPharmacyInfo(id: number): Observable<IPatientPharmacy> {
    const CheckPharmacy_PenRequest = {
      patientId: id,
      facility: sessionStorage.getItem("FacilityId"),
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<IPatientPharmacy>(
      `${configuration.apiUrl + 'Patient/GetPharmacy'}`, CheckPharmacy_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteSelectdPharmacyInfo(Id: number): Observable<string> {
    return this.http.delete<string>(`${configuration.apiUrl + 'Patient/Pharmacy'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getAuthorizationCodes(patientId: number): Observable<IAuthorization[]> {
    return this.http.get<IAuthorization[]>(
      `${configuration.apiUrl + 'Patient/AuthorizationCodes'}?patId=${patientId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getEmergencyInfoById(id: number): Observable<IEmergencyContact[]> {
    return this.http.get<IEmergencyContact[]>(
      `${configuration.apiUrl + 'Patient/ContactEmergencyInfo'}?patid=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  updateContactInfo(contactInfo: ContactInfo): Observable<string> {
    const signatureSizeImage = contactInfo.personInfo.patientPic;
    contactInfo.personInfo.patientPic = null;
    const posteddata = {
      inputdata: JSON.stringify(contactInfo),
      signature: (signatureSizeImage)
    }
    return this.http.put<string>(`${configuration.apiUrl + 'Patient/ContactEmgInfo'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getPatientEmailInfo(paymentId: number): Observable<string> {
    const PaymentReportMail_PenRequest = {
      paymentId: paymentId,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      locationId: sessionStorage.getItem("LocationId"),
      portal: null
    }
    return this.http.post<string>(
      `${configuration.apiUrl + 'Document/PaymentReportMail'}`, PaymentReportMail_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }



  getPersonalInfoByInsurance(id: number): Observable<IPersonalInfo> {
    const postedData = {
      patientid: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      clientid: sessionStorage.getItem("FacilityId")

    }
    return this.http.post<IPersonalInfo>(
      `${configuration.apiUrl + 'Patient/InsurancePersonalDetails'}`, postedData);
    // return this.http.get<IPersonalInfo>(
    //   `${configuration.apiUrl + 'Patient/InsurancePersonalDetails'}?patientid=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&clientid=${sessionStorage.getItem("FacilityId")}`);
  }



  //******** Patient Referral Tracker Info */
  savePatientReferralTrackerInfo(personInfo: IPatientReferralTrackers): Observable<IPatientReferralTrackers> {
    return this.http.post<IPatientReferralTrackers>(`${configuration.apiUrl + 'Patient/PatientReferralTracker'}`, personInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // getPatReferralTrackerDetails(): Observable<IPatientReferralTrackers[]> {
  //   return this.http.get<IPatientReferralTrackers[]>(
  //     `${configuration.apiUrl + 'Patient/PatientReferralTracker'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  // }

  getPatReferralTrackerDetails(appDate: string, userList: string, locationId: number, appstatusList: string, FromDate: string, ToDate: string, showall: string): Observable<IPatientReferralTrackers[]> {
    return this.http.get<IPatientReferralTrackers[]>(
      `${configuration.apiUrl + 'Patient/PatientReferralTracker'}?appDate=${appDate}&&userList=${encodeURIComponent(userList).toString()}&&locationId=${locationId}&&appstatusList=${appstatusList}&&FromDate=${FromDate}&&ToDate=${ToDate}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}&&showall=${showall}`);
  }


  savePatientReferralTrackerInfo1(personInfo: IPatientReferralTrackers): Observable<IPatientReferralTrackers> {
    return this.http.post<IPatientReferralTrackers>(`${configuration.apiUrl + 'Patient/PatientReferralTracker'}`, personInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  DeletePatientReferralTrackerInformation(Id: number): Observable<string> {
    return this.http.delete<string>(`${configuration.apiUrl + 'Patient/PatientReferralTracker'}?patientReferralTrackerId=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getAllReferralProvidersBySearch(searchstr: string, ascFacilityId: number = 0): Observable<IReferralDetails[]> {
    const postedData = {
      searchstr: searchstr,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: ascFacilityId == 0 ? sessionStorage.getItem("FacilityId") : ascFacilityId.toString()
    }

    return this.http.post<IReferralDetails[]>(
      `${configuration.apiUrl + 'Patient/GetReferralProvidersBySearch'}`, postedData);
    // return this.http.get<IReferralDetails[]>(
    //   `${configuration.apiUrl + 'Patient/GetReferralProvidersBySearch'}?searchstr=${searchstr}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  getPatientDetailsCount(lastName: string, firstName: string, middleName: string, dob: string): Observable<number> {
    const postedData = {
      lastName: lastName,
      firstName: firstName,
      middleName: middleName,
      dob: dob,
      clientId: sessionStorage.getItem("FacilityId"),
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString()

    }

    return this.http.post<number>(`${configuration.apiUrl + 'Patient/FilterPatientDetailsByName'}`, postedData);
    // return this.http.get<number>(`${configuration.apiUrl + 'Patient/FilterPatientDetailsByName'}?=${lastName}&&firastName=${firstName}&&middleName=${middleName}&&dob=${dob}&&clientId=${sessionStorage.getItem("FacilityId")}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getReferalProvidersInfoByProviderType(providerType: string): Observable<IReferralDetails[]> {
    const postedData = {
      providerType: providerType,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId")

    }

    return this.http.post<IReferralDetails[]>(`${configuration.apiUrl + 'Patient/ReferralProvidersByProviderType'}`, postedData);

    // return this.http.get<IReferralDetails[]>(`${configuration.apiUrl + 'Patient/ReferralProvidersByProviderType'}?providerType=${providerType}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }
  getPatientRequestInformationById(id: number): Observable<IPatientPortaInformation> {
    return this.http.get<IPatientPortaInformation>(
      `${configuration.apiUrl + 'Patient/PatientInformationByLinkId'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&linkId=${id}`);
  }
  getPersonalInfoPatientPortal(id: number): Observable<IPersonalInfo> {
    return this.http.get<IPersonalInfo>(
      `${configuration.apiUrl + 'Patient/PersonalPortal'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&linkId=${id}`);
  }
  updatePatientRequestInformationByLinkId(requestInfo: MessageInbox): Observable<MessageInbox> {
    const posteddata = {
      inputdata: JSON.stringify(requestInfo)
    }
    return this.http.post<MessageInbox>(`${configuration.apiUrl + 'Patient/UpdatePatientRequestByLinkId'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  //*** Display Patient Portal Insurance  Information */
  // getInsuranceRequestInformationByInsId(id: number, linkId: number): Observable<IInsuranceDetails> {
  //   return this.http.get<IInsuranceDetails>(
  //     `${configuration.apiUrl + 'Patient/PPInsurancebyId'}?id=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}&&linkId=${linkId}`);
  // }

  getInsuranceRequestInformationByInsId(id: number, linkId: number): Observable<IInsuranceDetails> {
    const PPInsurance_PenRequest = {
      id: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId"),
      linkId: linkId
    }
    return this.http.post<IInsuranceDetails>(
      `${configuration.apiUrl + 'Patient/PPInsurancebyId'}`, PPInsurance_PenRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  // PP Activation Access
  addPPAccessDetails(activationPP: IPPActivation): Observable<IPPActivation> {
    const posteddata = {
      inputdata: JSON.stringify(activationPP)
    }
    return this.http.post<IPPActivation>(`${configuration.apiUrl + 'Patient/PPActivation'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getPPActivationInfo(id: number): Observable<IPPActivation> {
    return this.http.get<IPPActivation>(
      `${configuration.apiUrl + 'Patient/PPActivation'}?patientid=${id}`);
  }

  getPatientPortalPersonalDetails(id: number): Observable<IPersonalInfo> {
    return this.http.get<IPersonalInfo>(
      `${configuration.apiUrl + 'Patient/PPortalPersonalDetails'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&linkId=${id}`);
  }
  getPPersonalInfo(id: number): Observable<IPersonalInfo> {
    const postedData = {
      patientid: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      clientid: sessionStorage.getItem("FacilityId")

    }
    return this.http.post<IPersonalInfo>(
      `${configuration.apiUrl + 'Patient/PPPersonal'}`, postedData);
    // return this.http.get<IPersonalInfo>(
    //   `${configuration.apiUrl + 'Patient/PPPersonal'}?patientid=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&clientid=${sessionStorage.getItem("FacilityId")}`);
  }

  getPPortalPersonalInfo(patientid: number, LinkId: number): Observable<IPersonalInfo> {
    const postdata = {
      patientid: patientid,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facilityId: sessionStorage.getItem("FacilityId"),
      LinkId: LinkId
    }
    return this.http.post<IPersonalInfo>(`${configuration.apiUrl + 'Patient/GetPPortalPersonalInfo'}`, postdata);
    // return this.http.get<IPersonalInfo>(`${configuration.apiUrl + 'Patient/GetPPortalPersonalInfo'}?patientid=${patientid}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${sessionStorage.getItem("FacilityId")}&&LinkId=${LinkId}`);
  }

  //*** Display Patient Portal Insurance By LinkId */

  getInsuranceRequestInformationByLinkId(id: number): Observable<IInsuranceDetails> {
    const postedData = {
      id: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId")

    }
    return this.http.post<IInsuranceDetails>(
      `${configuration.apiUrl + 'Patient/InsurancebyLinkId'}`, postedData);


    // return this.http.get<IInsuranceDetails>(
    //   `${configuration.apiUrl + 'Patient/InsurancebyLinkId'}?id=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  getInsuranceRequestInformationByPatientPortal(id: number): Observable<IInsuranceDetails> {

    const postedData = {
      id: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId")

    }
    return this.http.post<IInsuranceDetails>(
      `${configuration.apiUrl + 'Patient/InsurancebyLinkId'}`, postedData);

    // return this.http.get<IInsuranceDetails>(
    //   `${configuration.apiUrl + 'Patient/InsurancebyLinkId'}?id=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  getEmergencyRequestInformationByLinkId(id: number, requestType: number): Observable<IEmergencyContact> {
    const postedData = {
      id: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId"),
      requestType: requestType
    }

    return this.http.post<IEmergencyContact>(
      `${configuration.apiUrl + 'Patient/EmergencybyLinkId'}`, postedData);

    // return this.http.get<IEmergencyContact>(
    //   `${configuration.apiUrl + 'Patient/EmergencybyLinkId'}?id=${id}&&requestType=${requestType}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  getEmergencyRequestInformationById(id: number, linkid: number): Observable<IEmergencyContact> {
    const postedData = {
      id: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId"),
      linkid: linkid
    }
    return this.http.post<IEmergencyContact>(
      `${configuration.apiUrl + 'Patient/EmergencybyId'}`, postedData);
    // return this.http.get<IEmergencyContact>(
    //   `${configuration.apiUrl + 'Patient/EmergencybyId'}?id=${id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}&&linkid=${linkid}`);
  }

  getPPEmergencyInfoById(id: number, linkId: number): Observable<IEmergencyContact[]> {
    const postedData = {
      id: id,
      linkId: linkId,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<IEmergencyContact[]>(
      `${configuration.apiUrl + 'Patient/PPEmergencyById'}`, postedData);
  }

  GetAllPayerNameBySearch(searchstr: string): Observable<IInsuranceCarriers[]> {
    const postedData = {
      searchstr: searchstr,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facility: sessionStorage.getItem("FacilityId")

    }

    return this.http.post<IInsuranceCarriers[]>(
      `${configuration.apiUrl + 'Patient/GetPayerNameBySearch'}`, postedData);
    // return this.http.get<IReferralDetails[]>(
    //   `${configuration.apiUrl + 'Patient/GetReferralProvidersBySearch'}?searchstr=${searchstr}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }


  // Get Auth Insurance details drop down
  getAuthInsuranceDetails(id: number): Observable<IInsuranceDetails[]> {
    return this.http.get<IInsuranceDetails[]>(
      `${configuration.apiUrl + 'Patient/GetAuthorizationInsurance'}?id=${id}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  addDMPersonalInfo(personInfo: IPersonalInfo): Observable<IPersonalInfo> {
    const posteddata = {
      inputdata: JSON.stringify(personInfo),
      signature: null
    }
    return this.http.post<IPersonalInfo>(`${configuration.apiUrl + 'Patient/Personal'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getreferraltrackerInfo(Id: number): Observable<number> {
    return this.http.get<number>(`${configuration.apiUrl + 'Patient/PatReferralTrackerId'}?referId=${Id}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  // PP Activation Access For Representative
  addPPRepresentativeAccessDetails(activationPP: IPPActivation): Observable<IPPActivation> {
    const posteddata = {
      inputdata: JSON.stringify(activationPP)
    }
    return this.http.post<IPPActivation>(`${configuration.apiUrl + 'Patient/PPRepresentativeActivation'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getPPRepresentativeActivationInfo(id: number): Observable<IPPActivation> {
    return this.http.get<IPPActivation>(
      `${configuration.apiUrl + 'Patient/PPRepresentativeActivation'}?patientid=${id}`);
  }

  getAddressHistory(patid: number, type: string, spname: string): Observable<IAddressHistoryInfo[]> {
    const logidstr = patid.toString();
    return this.http.get<IAddressHistoryInfo[]>(`${configuration.apiUrl + 'Patient/XMLAddressHistory'}?patientid=${logidstr}&&actiontype=${type}&&spname=${spname}`);
  }
}



